import * as $ from '../../client-app/node_modules/jquery';

$.event.special.touchstart = {
    setup: function (_, ns, handle) {
        if (ns.includes("noPreventDefault")) {
            this.addEventListener("touchstart", handle, { passive: false });
        } else {
            this.addEventListener("touchstart", handle, { passive: true });
        }
    }
};

$.event.special.touchmove = {
    setup: function (_, ns, handle) {
        if (ns.includes("noPreventDefault")) {
            this.addEventListener("touchmove", handle, { passive: false });
        } else {
            this.addEventListener("touchmove", handle, { passive: true });
        }
    }
};        

$(document).ready(function () {

    // These are for git repo box behavior
    $('.text-copy').on('click', function () {
        $(this).prev('input').focus().select();
    });

    $(document).on('focus', 'input.auto-select', function (e) {
        $(this).select();
        e.preventDefault();
    });

    $(document).on('mouseup', 'input.auto-select', function (e) {
        $(this).select();
        e.preventDefault();
    });

    $(document).on('keypress', 'input.auto-select', function (e) {
        e.preventDefault();
    });

    // This is for git branch/tag filter behavior.
    $(document).on('click', 'input.dropdown-filter', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', '[data-toggle="sidebar"]', function (e) {
        var targetSelector = $(this).attr('data-target');
        if (targetSelector) {
            $(targetSelector).toggleClass('hidden-xs');
        }        
    });
});
